import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=1f906816&scoped=true&"
import script from "./CouponDetail.vue?vue&type=script&lang=ts&"
export * from "./CouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=1f906816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f906816",
  null
  
)

component.options.__file = "CouponDetail.vue"
export default component.exports